var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.currentVehicle
    ? _c(
        "div",
        { staticClass: "vehicle vehicle-card-car-camp d-flex" },
        [
          _c("div", { staticClass: "car-camp-hero" }, [
            _c("img", {
              staticClass: "car-camp-logo",
              attrs: {
                src: "/images/car-camp/car_camp_logo.png",
                alt: "Car and camp",
              },
            }),
            _vm._v(" "),
            _vm.currentVehicle.image
              ? _c(
                  "div",
                  {
                    class: [
                      "vehicle-img-wrapper expanded",
                      { "col-4 p-1": _vm.cardType === "us-source-booking" },
                    ],
                    style:
                      _vm.cardType === "us-source-booking"
                        ? "background-image:url(" +
                          _vm.imageUrl(_vm.currentVehicle.image) +
                          ")"
                        : "",
                  },
                  [
                    _c("div", {
                      staticClass:
                        "vehicle-image-overlay d-block d-lg-none expanded",
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass:
                        "vehicle-image vehicle-fixed-height expanded",
                      attrs: {
                        src: _vm.imageUrl(_vm.currentVehicle.image),
                        alt: _vm.currentVehicle.name,
                      },
                      on: {
                        error: function ($event) {
                          return _vm.imageLoadFailed(_vm.currentVehicle.image)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.loyaltyDiscountApplied
                      ? _c("img", {
                          staticClass: "loyalty-medal",
                          attrs: {
                            src: _vm.userLoyalty.image,
                            alt: _vm.userLoyalty.name,
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("vehicle-visual-summary", {
            attrs: {
              vehicle: _vm.vehicle,
              labels: _vm.labels,
              currentVehicle: _vm.currentVehicle,
              currencyIsChanging: _vm.currencyIsChanging,
              activeProduct: _vm.activeProduct,
              experiment: _vm.experiment,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "car-camp-details-block" },
            [
              _c("div", { staticClass: "car-camp-middle-wrapper" }, [
                _c("img", {
                  staticClass: "car-camp-logo",
                  attrs: {
                    src: "/images/car-camp/car_camp_logo.png",
                    alt: "Car and camp",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "car-camp-item-wrapper" }, [
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: "/images/svgs/GM_Car_&_Camp_Tent_&_Equipment.svg",
                        alt: _vm.$t("bookings.car_and_camp.tent_and_equipment"),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("bookings.car_and_camp.tent_and_equipment")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: "/images/svgs/GM_Car_&_Camp_Quick_&_Easy.svg",
                        alt: _vm.$t("bookings.car_and_camp.quick_and_easy"),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("bookings.car_and_camp.quick_and_easy"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: "/images/svgs/GM_Car_&_Camp_Travel_Freedom.svg",
                        alt: _vm.$t("bookings.car_and_camp.travel_freedom"),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("bookings.car_and_camp.travel_freedom"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-lg-none" }, [
                    _c("img", {
                      attrs: {
                        src: "/images/svgs/GM_Car_&_Camp_Affordable.svg",
                        alt: _vm.$t(
                          "bookings.car_and_camp.affordable_campervan_alternative"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "bookings.car_and_camp.affordable_campervan_alternative"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-lg-none" }, [
                    _c("img", {
                      attrs: {
                        src: "/images/svgs/GM_Lightweight_Compact.png",
                        alt: _vm.$t(
                          "bookings.car_and_camp.lightweight_and_compact"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "bookings.car_and_camp.lightweight_and_compact"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-lg-none" }, [
                    _c("img", {
                      attrs: {
                        src: "/images/svgs/GM_Car_&_Camp_Fully_Insured_Green.svg",
                        alt: _vm.$t("bookings.car_and_camp.fully_insured"),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("bookings.car_and_camp.fully_insured"))
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price-block-mobile" }, [
                _c("div", { staticClass: "foot" }, [
                  _c(
                    "button",
                    { staticClass: "link", on: { click: _vm.openSheet } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "bookings.drive_and_go.premium_plus_benefits_also_included"
                          )
                        )
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.shouldShowDetails
                  ? _c(
                      "div",
                      { staticClass: "mb-0 ml-4 w-100" },
                      [
                        _c("product-details", {
                          attrs: {
                            "show-terms-and-conditions":
                              _vm.showTermsAndConditions,
                            product: _vm.activeProduct,
                            "currency-is-changing": _vm.currencyIsChanging,
                            "upsell-card-type": "mobile-us-product-upsell",
                            experiment: _vm.experiment,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "book-default w-100" },
                  [
                    _c("div", { staticClass: "camp-price" }, [
                      _vm.activeProduct.original_price &&
                      !_vm.currencyIsChanging
                        ? _c("span", { staticClass: "was" }, [
                            _vm._v(
                              _vm._s(_vm.originalPrice(_vm.activeProduct))
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currencyIsChanging
                        ? _c("span", { staticClass: "amount" }, [_vm._v("…")])
                        : _c("span", { staticClass: "now" }, [
                            _vm._v(_vm._s(_vm.vehiclePrice)),
                          ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "per" }, [
                        _vm._v(_vm._s(_vm.labels.extraPerDay)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "total" }, [
                        _vm._v(
                          _vm._s(_vm.price(_vm.activeProduct)) +
                            " " +
                            _vm._s(_vm.labels.total)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.vehicle.is_drive_and_go &&
                    _vm.activeProduct.is_available
                      ? _c(
                          "gm-button",
                          {
                            attrs: {
                              type: "select",
                              "mobile-classes": true,
                              disabled: _vm.disabledButtonStatus,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectVehicleHandler(
                                  _vm.vehicle,
                                  _vm.activeProduct.id
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("bookings.book_now")) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.activeProduct.is_available
                      ? _c(
                          "gm-button",
                          {
                            attrs: {
                              "top-right-radius": "0",
                              "top-left-radius": "0",
                              disabled: true,
                              "mobile-classes": true,
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t("VehicleCard.age_limit", {
                                    age: _vm.activeProduct.minimum_age,
                                  })
                                ) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shouldShowSheet
                      ? _c("div", {
                          staticClass: "scrim",
                          attrs: { "data-close": "" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "slide-up" } }, [
                      _vm.shouldShowSheet
                        ? _c(
                            "div",
                            { staticClass: "vehicle-sheet sheet-wrap show" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "sheet",
                                  attrs: {
                                    role: "dialog",
                                    "aria-modal": "true",
                                    "aria-label":
                                      "What's included and how it works",
                                  },
                                },
                                [
                                  _c("h4", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "bookings.drive_and_go.premium_plus_benefits_also_included"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("product-details", {
                                    attrs: {
                                      "show-terms-and-conditions":
                                        _vm.showTermsAndConditions,
                                      product: _vm.activeProduct,
                                      "currency-is-changing":
                                        _vm.currencyIsChanging,
                                      "upsell-card-type":
                                        "mobile-us-product-upsell",
                                      experiment: _vm.experiment,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "close",
                                      attrs: { "data-close": "" },
                                      on: { click: _vm.openSheet },
                                    },
                                    [_vm._v("Close")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("price-card", {
                key: _vm.activeProduct.type,
                class: { active: true },
                attrs: {
                  product: _vm.activeProduct,
                  vehicle: _vm.currentVehicle,
                  labels: _vm.labels,
                  buy: _vm.buy,
                  "show-terms-and-conditions": _vm.showTermsAndConditions,
                  "currency-is-changing": _vm.currencyIsChanging,
                  "select-vehicle": _vm.selectVehicleHandler,
                  "selected-currency": _vm.selectedCurrency,
                  user: _vm.user,
                  "handle-login": _vm.handleLogin,
                  experiment: _vm.experiment,
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }